import { getCurrentOrg } from '@api/getCurrentOrg';

export const getAdminUrl = (withOrgId: boolean = true) => {
  const organization_id = getCurrentOrg();

  const url = window.location.origin.includes('dev-')
    ? window.location.origin.replace('outreach', 'admin')
    : window.location.origin.replace('outreach', 'uat-admin');

  return withOrgId ? `${url}/conversation/${organization_id}` : url;
};
